/**
 * Created by guga on 8/1/2016.
 */

export class RefreshToken {
    public expiration : number;
    public value      : string;
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/refresh-token.ts